<script lang="ts">
  import IndexLayout from '../../module_layout/index/index-layout.svelte'

  let { children } = $props()
</script>

<div class="app">
  <IndexLayout headerIsActive={true}>
    <main>
      {@render children()}
    </main>
  </IndexLayout>
</div>
